import { Injectable, inject } from '@angular/core'

import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { catchError, endWith, map, of, switchMap, takeUntil } from 'rxjs'

import { AgentChatActions } from './chat.actions'

import { AgentChatApi } from '../api/chat.api'

@Injectable()
export class AgentChatEffects {
  #actions$ = inject(Actions)
  #store = inject(Store)
  #agentChatApi = inject(AgentChatApi)

  getAgentResponse = createEffect(
    () =>
      this.#actions$.pipe(
        ofType(AgentChatActions.userSendMessage),
        switchMap(({ message, agentId, sessionId, image }) =>
          this.#agentChatApi
            .getAgentResponse({
              agentId,
              query: message,
              session_id: sessionId,
              image: image || null,
            })
            .pipe(
              map((response) => AgentChatActions.getAgentResponseStream({ response })),
              takeUntil(this.#actions$.pipe(ofType(AgentChatActions.cancelPendingRequest))),
              catchError((error) => of(AgentChatActions.getAgentResponseFailure({ error }))),
              endWith(AgentChatActions.getAgentResponseStreamCompleted())
            )
        )
      ),
    { dispatch: true }
  )
}
